import {
  CardContent,
  Typography,
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  useMediaQuery,
  Button,
  Chip,
  Card,
  Link,
} from "@mui/material";
import { ExpandMore, Image } from "@mui/icons-material";
import { NumericFormat } from "react-number-format";
import { CustomSelectMenuProps } from "../../../../../constants";
import CustomSelect from "../../../../components/CustomSelect";
import { useState } from "react";
import { useTheme } from "@mui/system";
import {
  CardContainer,
  formatPrice,
  FullWidthCard,
  SmallButton,
  KeyValueRow,
} from "../../../rcAutoDetails2/tabs/preventivi";
import Dettagli from "../../lib/Dettagli";
import { useFormRCAutoDetails } from "../../rcautoContext";

const CVT = () => {
  const { formState } = useFormRCAutoDetails();
  const dataset = formState.preventivi?.CVT || [];
  const [form, setForm] = useState({
    valoreVeicolo: "",
    satellitare: "",
  });
  const [ricalcolaButton, setRicalcolaButton] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);
  const [contentType, setContentType] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleExpand = (id, type) => {
    if (expandedItem === id && contentType === type) {
      setExpandedItem(null);
      setContentType(null);
    } else {
      setExpandedItem(id);
      setContentType(type);
    }
  };

  return (
    <Box>
      <Box display="flex" justifyContent="end" mb={4}>
        <Box
          display="flex"
          width={isMobile ? "100%" : "50%"}
          flexDirection={isMobile ? "column" : "row"}
          gap={4}
        >
          <NumericFormat
            customInput={TextField}
            prefix="€"
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={2}
            fullWidth
            id="ValoreVeicolo"
            name="ValoreVeicolo"
            label="Valore Veicolo"
            value={form.valoreVeicolo}
            onValueChange={(e) => {
              setForm((prev) => ({ ...prev, valoreVeicolo: e.floatValue }));
            }}
          />
          <CustomSelect
            label="Satellitare"
            name="satellitare"
            value={form.satellitare}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, satellitare: e.target.value }))
            }
            options={[
              { value: "no", label: "No" },
              { value: "si", label: "Si" },
            ]}
            MenuProps={CustomSelectMenuProps}
          />
          <Button
            variant="contained" /* onClick={() => setRicalcolaButton(true)} */
          >
            Ricalcola
          </Button>
        </Box>
      </Box>
      <Grid container direction="column">
        {dataset.length > 0 ? (
          dataset?.map((item) => {
            const isExpanded = expandedItem === item.idUID;
            return (
              <Grid item key={item.idUID}>
                <CardContainer
                  isExpanded={isExpanded}
                  mb={4}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: isMobile && "center",
                  }}
                >
                  <FullWidthCard>
                    {/* Left Section: Image and Compagnia */}
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      pt={2}
                      sx={{
                        minWidth: "220px",
                        flexBasis: isMobile ? "100%" : "15%",
                      }}
                    >
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        textAlign="center"
                        mb={1}
                        px={1}
                      >
                        {item.compagnia}
                      </Typography>
                      {item.image ? (
                        <img
                          src={`/static/img/companies/${item.image}`}
                          alt={item.Compagnia}
                          style={{
                            width: "110px",
                            height: "110px",
                            bgcolor: "gray",
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <Image
                          alt={item.Compagnia}
                          src={item.logo || ""}
                          sx={{
                            width: 80,
                            height: 80,
                            bgcolor: "gray",
                            marginBottom: 1,
                          }}
                        />
                      )}
                    </Box>

                    {/* Center Section: KeyValueRow */}
                    <CardContent
                      sx={{
                        flexGrow: 1,
                        padding: 2,
                        flexBasis: isMobile ? "100%" : "70%",
                        // background: "grey",
                      }}
                    >
                      {Object.entries(item.info)
                        .filter((el) => el[1] !== "")
                        .map(
                          ([key, value], id) =>
                            value !== "" && (
                              <KeyValueRow key={id} isEven={id % 2 === 0}>
                                <Typography
                                  variant="body2"
                                  color="textPrimary"
                                  fontWeight="bold"
                                  textAlign="right"
                                >
                                  {key}:
                                </Typography>

                                {key === "Guida" ? (
                                  <Chip
                                    label={value}
                                    color={
                                      value === "Libera" ? "success" : "warning"
                                    }
                                    sx={{
                                      ...(value === "Libera" && {
                                        backgroundColor: "#2e7d32",
                                      }),
                                      color: "white",
                                      height: 20,
                                      fontWeight: "bold",
                                    }}
                                  />
                                ) : key === "Emissione" ? (
                                  <Chip
                                    label={value}
                                    color={
                                      value === "Emissione immediata"
                                        ? "success"
                                        : value === "Richiesta documenti"
                                        ? "warning"
                                        : "error"
                                    }
                                    sx={{
                                      ...(value === "Emissione immediata" && {
                                        backgroundColor: "#2e7d32",
                                      }),
                                      color: "white",
                                      height: 20,
                                      fontWeight: "bold",
                                    }}
                                  />
                                ) : (
                                  <Typography variant="body2" textAlign="right">
                                    {value || "-"}
                                  </Typography>
                                )}
                              </KeyValueRow>
                            ),
                        )}
                    </CardContent>

                    {/* Right Section: Price and Button */}
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      pt={1}
                      sx={{
                        flexBasis: isMobile ? "100%" : "15%",
                        textAlign: "center",
                        minWidth: "220px",
                        // width: "100%",
                        justifyContent: "space-between",
                        height: "100px",
                        // background: "yellow",
                      }}
                    >
                      <Typography
                        variant="h2"
                        fontWeight="bold"
                        color="#FE6A00"
                        mb={4}
                      >
                        {formatPrice(item.prezzoTotale)}
                      </Typography>
                      <Button
                        sx={{
                          background: "#5cb85c",
                          color: "white",
                          width: "80%",
                          fontSize: "1rem",

                          "&:hover": {
                            background: "#499149",
                          },
                        }}
                      >
                        VAI
                      </Button>
                    </Box>
                  </FullWidthCard>
                  <Box display="flex" justifyContent="flex-start" p={2}>
                    <SmallButton
                      onClick={() => handleExpand(item.idUID, "table")}
                      sx={{ mr: 2 }}
                      $isActive={
                        expandedItem === item.idUID && contentType === "table"
                      }
                    >
                      <ExpandMore
                        sx={{
                          transform:
                            isExpanded && contentType === "table"
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          transition: "transform 0.3s",
                        }}
                      />
                      Documenti
                    </SmallButton>

                    <SmallButton
                      onClick={() => handleExpand(item.idUID, "list")}
                      $isActive={
                        expandedItem === item.idUID && contentType === "list"
                      }
                    >
                      <ExpandMore
                        sx={{
                          transform:
                            isExpanded && contentType === "list"
                              ? "rotate(180deg)"
                              : "rotate(0deg)",
                          transition: "transform 0.3s",
                        }}
                      />
                      Espandi con Elenco
                    </SmallButton>
                  </Box>

                  {isExpanded && (
                    <Box p={2} width={"100%"}>
                      {contentType === "table" && (
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell>Nome</TableCell>
                              <TableCell>Tipo</TableCell>
                              <TableCell>Fonte</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {item?.documenti.length > 0 &&
                              item?.documenti.map((documento) => (
                                <TableRow key={documento?.idUidDocumento}>
                                  <TableCell>
                                    <Link
                                      sx={{
                                        cursor: "pointer",
                                        color:
                                          theme.palette.mode === "light"
                                            ? "#0c4bb7"
                                            : "#5c92e1",
                                        fontWeight: 900,
                                      }}
                                      onClick={() =>
                                        console.log(
                                          "Link clicked" /*documento?.idUidDocumento */,
                                        )
                                      }
                                    >
                                      {documento?.nome}
                                    </Link>
                                  </TableCell>
                                  <TableCell>{documento?.tipo}</TableCell>
                                  <TableCell>{documento?.fonte}</TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      )}
                      {contentType === "list" && (
                        <Dettagli idUID={item.idUID} type="CVT" />
                      )}
                    </Box>
                  )}
                </CardContainer>
              </Grid>
            );
          })
        ) : (
          <Card>
            <CardContent>
              <Typography variant="h5" textAlign="center">
                Nessun preventivo disponibile
              </Typography>
            </CardContent>
          </Card>
        )}
      </Grid>
    </Box>
  );
};

export default CVT;
